import { Accordion, FormControl, Table } from "react-bootstrap";
import React, { useEffect } from "react";
import ControllerActionRow from "./ControllerActionRow";

const actionMethods = [
  "delete",
  "dispatch",
  "find",
  "fire",
  "flash",
  "notify",
  "query",
  "redirect",
  "render",
  "resource",
  "respond",
  "save",
  "send",
  "store",
  "update",
  "validate"
];

export default function ControllerMethod(props) {
  const [summary, setSummary] = React.useState({});

  function updateSummary(method, value) {
    const update = { [method]: "            " + value };
    const result = { ...summary, ...update };
    setSummary(result);
  }

  function getConcatSummary() {
    let concatString = "        " + props.cmethod + ":\n";
    let successCounter = 0;
    for (const [key, value] of Object.entries(summary)) {
      console.log(value);
      if (value.length > 12) {
        successCounter++;
        concatString += value + "\n";
      }
    }
    return successCounter == 0 ? "" : concatString;
  }

  useEffect(() => {
    props.updateModelSummary([props.cmethod], getConcatSummary());
  }, [summary]);

  return (
    <Accordion.Item eventKey={props.ci}>
      <Accordion.Header key={props.ci}>
        {props.cmethod.charAt(0).toUpperCase() + props.cmethod.slice(1)} method
      </Accordion.Header>
      <Accordion.Body key={props.ci}>
        {/* <FormControl
          as="textarea"
          placeholder="Custom action"
          value={getConcatSummary()}
          disabled
        /> */}
        <Table striped bordered hover key={props.ci}>
          <thead>
            <tr>
              <th>Action</th>
              <th>Content</th>
              <th>Generated text</th>
            </tr>
          </thead>
          <tbody>
            {actionMethods.map((amethod, ai) => (
              <ControllerActionRow
                amethod={amethod}
                cmethod={props.cmethod}
                updateSummary={updateSummary}
                ai={ai}
                mi={props.ci}
              />
            ))}
          </tbody>
        </Table>
      </Accordion.Body>
    </Accordion.Item>
  );
}
